import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';

import classes from '../../css/getCSS';


const activityDeleteDialog = (props) => {
  let text = null;

  if (props.type === 'shortlists') {
    text = 'Want to delete this shortlist? Please go to <b>Shortlists</b> from your profile menu to remove this profile from your list.';
  }
  if (props.type === 'interests') {
    text = 'Sent it by mistake? Please go to <b>Interests</b> from your profile menu to <b>undo</b> this interest, if you sent it within the last <b>30 minutes</b>.';
  }
  if (props.type === 'requests') {
    text = 'Sent it by mistake? Please go to <b>Requests</b> from your profile menu to <b>undo</b> this request, if you sent it within the last <b>30 minutes</b>.';
  }
  text = <span dangerouslySetInnerHTML={{ __html: text }} />;  // eslint-disable-line

  return (
    <Dialog
      fullWidth
      open={props.open}
      onClose={props.close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{
        paper: classes.dialogCard,
      }}
    >
      <DialogTitle id="alert-dialog-title">Alert!</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.close} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default activityDeleteDialog;



// WEBPACK FOOTER //
// ./src/activities/components/ActivityDeleteDialog.js